import { http } from ".."
import { assignCurriculumToClassProps, getCurriculumAssignmentPayload, getCurriculumsPayload } from "./curriculum-interface"

export const getCurriculums = (data: getCurriculumsPayload) => {
	return http.get('/curriculums-v2', {
		params: {
			...data
		}
	})
}

export const getCurriculumAssignmentForStudent = (curriculumAssignmentId: string) => {
	return http.get(`/curriculum-assignments/${curriculumAssignmentId}`)
}

export const getCurriculumAssignment = (data: getCurriculumAssignmentPayload) => {
	return http.get('/curriculum-assignments', {
		params: {
			...data
		}
	})
}

export const getCurriculumAssignmentForTeacher = (curriculumId: string) => {
	return http.get(`/curriculum-assignments/teacher/${curriculumId}`)
}

export const assignCurriculumToClass = (data: assignCurriculumToClassProps) => {
	return http.post(`/curriculum-assignments/assign-to-class`, data)
}

export const createCurriculum = (data: any) => {
	return http.post('/curriculums-v2', data)
}

export const getCurriculum = (curriculumId: string) => {
	return http.get(`/curriculums-v2/${curriculumId}`)
}

export const getLanguages = () => {
	return http.get('/languages')
}

export const getLevels = () => {
	return http.get('/levels')
}